// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"81d91dbc","374":"fa9711aa","401":"b43f7bee","763":"a3843c95","788":"ce07ef46"}[chunkId] + ".chunk.js";
};